import bg1 from "./bg1.jpg";
import bg2 from "./bg2.jpg";

import arrows from "./arrows.png";

import marvel1 from "./marvel1.png";
import marvel2 from "./marvel2.png";
import marvel3 from "./marvel3.png";
import marvel4 from "./marvel4.png";

import dc1 from "./dc1.png";
import dc2 from "./dc2.png";
import dc3 from "./dc3.png";

import comicStamp1 from "./comic_stamps1.png";
// import comicStamp2 from "./comic_stamps2.png";
// import comicStamp3 from "./comic_stamps3.png";
// import comicStamp4 from "./comic_stamps4.png";
import comicStamp5 from "./comic_stamps5.png";
import comicStamp6 from "./comic_stamps6.png";
import comicStamp7 from "./comic_stamps7.png";
import comicStamp8 from "./comic_stamps8.png";
import comicStamp9 from "./comic_stamps9.png";
import comicStamp10 from "./comic_stamps10.png";

import restart from "./comic_stamps2.png";

import arrow from "./arrow.png";

const bgImages = [bg1, bg2];
const marvel = [marvel1, marvel2, marvel3, marvel4];
const dc = [dc1, dc2, dc3];
const comicStamps = [
    comicStamp1,
    // comicStamp2,
    // comicStamp3,
    // comicStamp4,
    comicStamp5,
    comicStamp6,
    comicStamp7,
    comicStamp8,
    comicStamp9,
    comicStamp10,
];

export { bgImages, arrows, marvel, dc, comicStamps, restart, arrow };
